import { Contact } from "../components/Contact"
import { Footer } from "../components/Footer";
import { Nav } from "../components/Nav";
import { Seo } from "../components/Seo";

export const ContactPage = () => {
	return (
		<>
			<Seo title="Discuss Your Central Texas Development Project | Gova" description="Contact Gova Engineering about site development, permitting, utilities, drainage, or project management in Central Texas." path="/contact" />
			<Nav />
			<Contact />
			<Footer />
		</>
	);
};
